<template>
  <v-card style="height: 100%">
    <div
      style="position: absolute; top: 0; right: 0; left: 0; height: 50px"
      class="border-bottom"
    >
      <v-tabs v-model="sidemenuTab" color="secondary" fixed-tabs>
        <v-tabs-slider></v-tabs-slider>
        <v-tab v-if="!selectedTabData.pxMode" href="#comments" class="font-s">
          Kommentare
        </v-tab>

        <v-tab v-if="!selectedTabData.pxMode" href="#documents" class="font-s">
          Dokumente
        </v-tab>
        <v-tab
          v-if="!selectedTabData.pxMode"
          href="#description"
          class="font-s"
        >
          Beschreibung
        </v-tab>
        <v-tab v-if="!selectedTabData.pxMode" href="#mngmtLinks" class="font-s">
          Links
        </v-tab>
        <v-tab v-if="selectedTabData.pxMode" href="#pxQuestions" class="font-s">
          PX Fragen
        </v-tab>
      </v-tabs>
    </div>
    <div>
      <v-tabs-items
        v-model="sidemenuTab"
        style="position: absolute; top: 50px; right: 0; left: 0; bottom: 0"
      >
        <v-tab-item v-if="!selectedTabData.pxMode" :key="2" value="comments">
          <CommentsSection
            :uuid="selectedTabData.uuid"
            :elementId="selectedTabData.selectedElement.id"
            @refresh="processChanged"
          />
        </v-tab-item>
        <v-tab-item v-if="!selectedTabData.pxMode" :key="3" value="documents">
          <DocumentSection
            :canEdit="canEdit"
            :uuid="selectedTabData.uuid"
            :elementId="selectedTabData.selectedElement.id"
            @refresh="processChanged"
          />
        </v-tab-item>
        <v-tab-item v-if="!selectedTabData.pxMode" :key="4" value="questions">
          <QuestionSection
            :canEdit="canEdit"
            :uuid="selectedTabData.key"
            :elementId="selectedTabData.selectedElement.id"
          />
        </v-tab-item>
        <v-tab-item v-if="!selectedTabData.pxMode" :key="4" value="description">
          <ElementDescriptionSection
            :canEdit="canEdit"
            :uuid="selectedTabData.key"
            :elementId="selectedTabData.selectedElement.id"
            @refresh="processChanged"
            :element="selectedTabData.selectedElement"
          />
        </v-tab-item>
        <v-tab-item v-if="!selectedTabData.pxMode" :key="5" value="mngmtLinks">
          <MngmtLinkSection
            :canEdit="canEdit"
            :uuid="selectedTabData.uuid"
            :elementId="selectedTabData.selectedElement.id"
            @refresh="processChanged"
          />
        </v-tab-item>
        <v-tab-item v-if="selectedTabData.pxMode" :key="5" value="pxQuestions">
          <PxQuestionSection
            :uuid="selectedTabData.key"
            :element="selectedTabData.selectedElement"
            @refresh="processChanged"
            @generateSurvey="saveFile"
          />
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-card>
</template>

<script>
import CommentsSection from "@/pages/ProcessModeling/Menu/CommentsSection/CommentsSection";
import QuestionSection from "@/pages/ProcessModeling/Menu/QuestionSection/QuestionSection";
import DocumentSection from "@/pages/ProcessModeling/Menu/DocumentSection/DocumentSection.vue";
import PxQuestionSection from "@/pages/ProcessModeling/Menu/PxQuestionSection/PxQuestionSection.vue";
import ElementDescriptionSection from "./Menu/ElementDescriptionSection/ElementDescriptionSection.vue";
import MngmtLinkSection from "./Menu/MngmtLinkSection/MngmtLinkSection.vue";
export default {
  components: {
    CommentsSection,
    DocumentSection,
    QuestionSection,
    PxQuestionSection,
    MngmtLinkSection,
    ElementDescriptionSection,
  },
  props: ["selectedTabData", "canEdit"],
  data: function () {
    return {
      sidemenuTab: "comment",
    };
  },

  async mounted() {},
  computed: {},
  methods: {
    processChanged() {
      this.$emit("processChanged");
    },
    saveFile() {
      this.$emit("saveFile");
    },
  },
};
</script>